export default __webpack_public_path__ + "static/media/cover4.90c0d8d6.jpg";